/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PendingSafetyCheck = {
  code: string;
  id: string;
  message: string;
};

/** @internal */
export const PendingSafetyCheck$inboundSchema: z.ZodType<
  PendingSafetyCheck,
  z.ZodTypeDef,
  unknown
> = z.object({
  code: z.string(),
  id: z.string(),
  message: z.string(),
});
/** @internal */
export type PendingSafetyCheck$Outbound = {
  code: string;
  id: string;
  message: string;
};

/** @internal */
export const PendingSafetyCheck$outboundSchema: z.ZodType<
  PendingSafetyCheck$Outbound,
  z.ZodTypeDef,
  PendingSafetyCheck
> = z.object({
  code: z.string(),
  id: z.string(),
  message: z.string(),
});

export function pendingSafetyCheckToJSON(
  pendingSafetyCheck: PendingSafetyCheck,
): string {
  return JSON.stringify(
    PendingSafetyCheck$outboundSchema.parse(pendingSafetyCheck),
  );
}
export function pendingSafetyCheckFromJSON(
  jsonString: string,
): SafeParseResult<PendingSafetyCheck, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PendingSafetyCheck$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PendingSafetyCheck' from JSON`,
  );
}
